<template>
  <v-container>
    <avs-backButton
      v-if="!inDialog"
      backTo="Actions"
    />
    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <template v-slot:headers>
        <AvsStep step="1"> </AvsStep>
      </template>
      <template v-slot:items>
        <v-stepper-content step="1">
          <v-form
            ref="form-informations"
            v-model="isFormValid.informations"
            class="pt-2 mb-5"
            lazy-validation
          >
            <ProjectAction
              :value="action"
              :projectId="projectId"
              @update="handleActionUpdate"
              @isSaved="updateIsSaved"
              @isSigned="updateIsSign"
            />
          </v-form>
        </v-stepper-content>
      </template>
      <v-spacer></v-spacer>
    </AvsSteppers>
  </v-container>
</template>

<script>
import { mkNCAction } from "@/utils/datamodels"
import { ProjectAction } from "@/components"
import { NonConformityService } from "@/services"
import _ from "lodash"
export default {
  name: "NonConformityCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue"),
    // DateInput,
    ProjectAction
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      action: mkNCAction(null, 1),
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      loading: false,
      step: -1,
      isFormValid: {
        informations: false
      },
      validateRequest: {
        pictures: 0
      },
      areasData: {},
      signatures: undefined,
      isDisable: false,
      isClosed: false,
      closeDialogIsOpen: false
    }
  },
  methods: {
    handleActionUpdate(value) {
      this.action = value
    },
    updateIsSaved(value) {
      this.$emit("isSaved", value)
    },
    updateIsSign(value) {
      this.$emit("isSigned", value)
    },
    fetchAction() {
      // Load nonconformity
      this.getAction(this.id)
    },
    getAction(id) {
      if (id) {
        let t = this
        NonConformityService.getAction(id).then(r => {
          Object.assign(this.action, r)
          // t.action = r
          t.actionRef = _.cloneDeep(t.action)
          if (t.action.state === 4) {
            t.isDisable = true
          }
          if (t.action.status == "Closed") {
            t.isClosed = true
          }
        })
      }
    }
  },
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    },
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    }
  },
  created() {
    this.fetchAction()
  },
  watch: {
    action: {
      deep: true,
      handler(newVal) {
        console.log("Action mise à jour :", newVal)
      }
    }
  }
}
</script>

<style lang="scss">
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.stepper-item {
  flex: 1 1 auto;
  overflow-y: auto;
}
.ck.ck-editor__main > .ck-editor__editable {
  height: 130px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
